import { Button, Checkbox, FormControlLabel, FormGroup, Stack, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useCurrentRefinements, useRefinementList } from "react-instantsearch-core"

import { sendFilterChangedEvent } from "@/utils/posthog"

import { FilterCheckboxCheckedIcon, FilterCheckboxIcon } from "./components/FilterCheckboxIcons"
import FilterSection, { CountBadge } from "./components/FilterSection"

const MATERIAL_LIMIT = 10
const MATERIAL_SHOW_MORE_LIMIT = 50

export default function MaterialFilter() {
  const { t } = useTranslation("items")
  const {
    items,
    refine,
    canRefine: hasMaterials,
    canToggleShowMore,
    isShowingMore,
    toggleShowMore,
  } = useRefinementList({
    attribute: "material",
    sortBy: ["count:desc", "name:asc"],
    limit: MATERIAL_LIMIT,
    showMore: true,
    showMoreLimit: MATERIAL_SHOW_MORE_LIMIT,
  })

  const { items: currentRefinements } = useCurrentRefinements({
    includedAttributes: ["material"],
  })

  const activeCount = currentRefinements.reduce(
    (count, attribute) => count + attribute.refinements.length,
    0
  )

  if (!hasMaterials && activeCount === 0) {
    return null
  }

  return (
    <FilterSection title={t("material")} activeCount={activeCount} trackingKey="material">
      <Stack
        sx={{
          gap: 0.5,
        }}
      >
        {items.map((item) => (
          <FormGroup key={String(item.value)}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={item.isRefined}
                  onChange={() => {
                    sendFilterChangedEvent({
                      filterGroup: "material",
                      filterKey: String(item.value),
                      filterLabel: item.label,
                      isActive: !item.isRefined,
                      value: item.label,
                      metadata: {
                        result_count: item.count,
                      },
                    })
                    refine(item.value)
                  }}
                  size="small"
                  icon={<FilterCheckboxIcon />}
                  checkedIcon={<FilterCheckboxCheckedIcon />}
                />
              }
              label={
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Typography
                    sx={{
                      flexGrow: 1,
                      fontSize: "0.875rem",
                    }}
                  >
                    {item.label}
                  </Typography>
                  {item.count != null && <CountBadge value={item.count} />}
                </Stack>
              }
              sx={{
                marginRight: 0,
                marginLeft: "-7px",
                "& .MuiFormControlLabel-label": {
                  width: "100%",
                },
              }}
            />
          </FormGroup>
        ))}
        {canToggleShowMore && (
          <Button
            variant="text"
            color="inherit"
            size="small"
            onClick={toggleShowMore}
            sx={{
              alignSelf: "center",
              paddingX: 2,
              paddingY: 0.75,
              textTransform: "none",
            }}
          >
            {isShowingMore ? t("ShowLess") : t("ShowMore")}
          </Button>
        )}
      </Stack>
    </FilterSection>
  )
}
